module.exports = __webpack_public_path__ + "static/media/search-outline.755e3004.svg";